import { useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Tooltip } from '@mui/material';
import { Grid } from '@mui/system';
import { BoxedTypography } from './BoxedUrlWithCopy.styles';

interface BoxedUrlWithCopyProps { copyButtonTestId?: string;url: string; urlTestId?: string;}

const BoxedUrlWithCopy = ({ copyButtonTestId, url, urlTestId }: BoxedUrlWithCopyProps) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(url);
    setTooltipOpen(true);
  };

  const handleMouseLeave = () => {
    setTooltipOpen(false);
  };

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid>
        <BoxedTypography variant="body1" data-testid={urlTestId}>{url}</BoxedTypography>
      </Grid>
      <Grid>
        <Tooltip title="Copied to clipboard!" open={tooltipOpen} onClose={() => setTooltipOpen(false)} placement="top">
          <IconButton data-testid={copyButtonTestId} onClick={handleCopy} onMouseLeave={handleMouseLeave}>
            <ContentCopyIcon />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default BoxedUrlWithCopy;
